<style scoped>
/*tbl mob*/
.rank-tbl-mob {
  display: block;
}

.rank-tbl .table td,
.table th {
  border-top: 1px solid #dee2e6;
}

.rank-tbl .table tr:hover td,
.table tr:hover th {
  border-top: 1px solid #000000;
  border-bottom: 1px solid #000000;
}

.rank-tbl-mob table tbody tr td:first-child {
  background: #59636b57;
}

.rank-tbl-mob .table-outer {
  border: 0px solid #e1e1e1;
  padding: 0px;
  overflow-y: scroll !important;
}

.rank-tbl-mob table tbody tr:nth-child(1) td:first-child span,
.rank-tbl-mob table tbody tr:nth-child(2) td:first-child {
  background: #FCB913 !important;
}

.rank-tbl-mob table tbody tr:nth-child(3) td:first-child span,
.rank-tbl-mob table tbody tr:nth-child(4) td:first-child {
  background: #62C3EC !important;
}

.rank-tbl-mob table tbody tr:nth-child(5) td:first-child span,
.rank-tbl-mob table tbody tr:nth-child(6) td:first-child {
  background: #EA5F28 !important;
}

/* .rank-tbl-mob table tr.active td span {
  background: #91c951;
  color: #ffffff;
} */


td.result-second-row {
  border-bottom: 1px solid #e1e1e1 !important;
}

.rank-tbl-mob table tr td span {
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 19px;
  text-align: center;
  width: 45px;
  height: 60px;
  display: inline-block;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rank-tbl-mob table tr.active td {
  font-weight: 700;
}

.rank-tbl-mob table tr td {
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  /*line-height: 19px;*/
  align-items: center;
  color: #000000;
  background-color: transparent;
  border: none;
  vertical-align: middle;
}

.rank-tbl-mob .teamsText {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 19px;
  color: #59636B;
  text-transform: uppercase;
}

.hide-row-mob {
  background: #ffffff00;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */
  color: #000000;
}

div.rank-tbl-mob table tbody tr td>div {
  display: flex;
  align-items: center;
}

.hide-row-mob td p {
  margin: 1px 0;
}

.hide-row-mob td p.light-txt {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 15px;
  /* identical to box height */


  /* trietryblack */

  color: #59636B;
}

.hide-row-mob td {
  padding: 12px 21px;
}

.user-category {
  background: #000000;
  color: #ffffff;
  border-radius: 50%;
  margin-left: -18px;
  font-size: 12px;
  margin-bottom: -24px;
  height: 18px;
  width: 18px;
  text-align: center;
  vertical-align: middle;
}

.hide-row-mob td p strong {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 11px;
  line-height: 17px;
  /* identical to box height */
  color: #000000;
}

@media (min-width: 1200px) {

  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    max-width: 1320px;
  }
}

/*.rank-tbl table tr:nth-child(even) {*/
/*  background: #f1f1f1;*/
/*}*/

.rank-tbl table tr th {
  color: #282828;
  background: #F3F3F3;
}

.rank-tbl table tbody tr:hover {
  border: 1px solid #000000;
}

/*.rank-tbl table tr:hover td,*/
/*.rank-tbl table tr:hover p {*/
/*  color: #ffffff;*/
/*}*/

/*.rank-tbl table tr.active {*/
/*  border: 2px solid #fcb913 !important;*/
/*}*/

/* .rank-tbl table tr td span{
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 39px;
  text-align: center;
  color: #FFFFFF;
} */

.rank-tbl table tr td span {
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 19px;
  text-align: center;
  width: 69px;
  height: 69px;
  display: inline-block;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.teamsText {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #59636B;
  margin: 0;
}

.rank-tbl table tbody tr {
  background: #fff !important;
  border: 1px solid #dee2e6;
}

.rank-tbl table tr.active td span {
  background: #91c951;
  color: #ffffff;
}

/* .rank-tbl table tr:hover {
  border: 2px solid #fcb913 !important;
} */
.rank-tbl table tr.active td {
  font-weight: 700;
  padding: 0px 20px;
}

.rank-tbl table tr td .jersey-img img {
  width: 100%;
  height: 100%;
}

.rank-tbl table tr td .jersey-img {
  width: 64px;
  height: 64px;
  text-align: center;
  /*margin-right: 10px;
  margin-top: 22px;*/
}

.rank-tbl table tr td .jersey-img img {
  width: 100%;
  height: 100%;
}

/* .rank-tbl table tr.active td .jersey-img img {
  width: 76px;
} */

.rank-tbl table tr td {
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  align-items: center;
  color: #000000;
  background-color: transparent;
  /*border-bottom: 1px solid #eee;*/
  padding: 0px 20px;
  vertical-align: middle;
}

.rank-tbl .table-outer {
  border: 0px solid #e1e1e1;
  padding: 0px;
  overflow-y: scroll !important;
}

.rank-tbl .div-flex {
  display: flex;
  align-items: center;
  justify-content: inherit;
}


.vis-none {
  visibility: hidden;
}

.table.dataTable tr td.separate-list {
  border-left: 0px solid #fcb913;
  padding: 0;
  overflow-y: scroll !important;
}

.table.dataTable tr td.separate-list ul li {
  min-height: 40px;
  border-bottom: 0px solid #fcb913;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.txt-flex-s {
  justify-content: flex-start !important;
  padding-left: 12px;
}

.table.dataTable tr td.separate-list ul li {
  /* padding-left: 12px; */
}

.table.dataTable tr td.separate-list ul li div {
  display: inline-block;
}

.table.dataTable tr td.separate-list img {
  max-width: 20px !important;
  margin-right: 5px;
}

/*.rank-tbl table tr.active {*/
/*  border: 0px solid #fcb913 !important;*/
/*}*/

.rank-tbl table tbody tr:nth-child(2) td:first-child span {
  background: #FCB913;
}

.rank-tbl table tbody tr:nth-child(3) td:first-child span {
  background: #00B2E3;
}

.rank-tbl table tbody tr:nth-child(4) td:first-child span {
  background: #EA5F28;
}

.rank-tbl table tbody tr td:first-child span {
  background: #59636b57;
  width: 52px;
  height: 80px;
  margin-left: -20px;
}


/*Media queris*/
@media (max-width: 575px) {
  .rank-tbl .container {
    padding: 0;
  }

  .rank-tbl-mob .container {
    padding: 0;
  }

  .rank-tbl-mob table tr td {
    font-size: 10px;
  }

}


/*rank table end*/


/*table css*/
table.table.overall-ind-table tr td {
  padding: 0;
}

.result-col {
  float: left;
  margin: 9px;
}


.playerNameTruncate {
  white-space: nowrap;
  width: 155px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.playerNameTruncateMbl {
  white-space: nowrap;
  width: 120px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
</style>

<template>
  <page-loader v-if="loader" style="margin-top: 50px"/>

  <!--tbl start-->
  <div v-if="isMobileDevice" class="rank-tbl-mob">
    <div class="container-fluid p-0">
      <div class="table-outer">
        <table class="table overall-ind-table">
          <tbody>
          <template v-for="(row, index) in players" :key="index">
            <tr class="active" scope="row">
              <td scope="col" width="20px">
                <span :class="index === 0 && 'active'">{{ row.rank }}</span>
              </td>
              <td scope="col" width="60px">
                <div class="jersey-img div-flex">
                  <div v-html="row.jerseyImage"></div>
                  <div class="user-category" v-if="row.categoryId != 0">{{ row.categoryId }}</div>
                </div>
                <!--                <div class="jersey-img" v-html="row.jerseyImage"></div>-->
              </td>
              <td scope="col" style="width: 125px !important;">
                <p class="mb-0 playerNameTruncateMbl" v-html="row.userFullName"></p>
                <p class="teamsText"><strong v-html="mapCountryFlag(row.userCountryFlag, '20px', '20px')"></strong>
                  {{ row.teamName }}</p>
              </td>
              <!--              <td scope="col" class="text-center" v-if="hidePoints"-->
              <!--                  v-html="'+' + formatTime(row.finishedTime - players[0].finishedTime)"></td>-->
              <td scope="col" class="text-right pr-2" v-if="hidePoints" v-html="formatTime(row.finishedTime)"></td>
              <td scope="col" class="text-right pr-2" v-if="!hidePoints" v-html="row.points"></td>
            </tr>
            <tr scope="row" class="hide-row-mob">
              <!--              <td scope="col"></td>-->
              <!--              <td scope="col" class="text-left pl-2 pr-2">-->
              <!--                <p><strong v-html="row.avgPower"></strong></p>-->
              <!--                <p class="light-txt">Avg W</p>-->
              <!--              </td>-->
              <!--              <td scope="col" class="pl-2 pr-2">-->
              <!--                <p><strong v-html="row.wattPerKG"></strong></p>-->
              <!--                <p class="light-txt">Avg w/kg</p>-->
              <!--              </td>-->
              <!--              <td scope="col" class="text-left pl-2 pr-2">-->
              <!--                <p><strong v-html="row.avgHeartRate"></strong></p>-->
              <!--                <p class="light-txt">HR bpm</p>-->
              <!--              </td>-->


              <td scope="col"></td>
              <td class="result-second-row" scope="col" colspan="4">
                <div class="result-col">
                  <p><strong v-html="row.avgPower"></strong></p>&nbsp;
                  <p class="light-txt">Avg W</p>
                </div>
                <div class="result-col">
                  <p><strong v-html="row.wattPerKG"></strong></p>&nbsp;
                  <p class="light-txt">Avg w/kg</p>
                </div>
                <div class="result-col">
                  <p><strong v-html="row.avgHeartRate"></strong></p>&nbsp;
                  <p class="light-txt">HR bpm</p>
                </div>
              </td>

            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!--tbl end-->

  <div v-else class="rank-tbl">
    <div class="container">
      <!--      <div class="table-outer tab" data-id="tab2">-->
      <table class="table" style="border: 1px solid #f2f2f2">
        <tbody>
        <tr scope="row">
          <th scope="col">Rank</th>
          <th scope="col"></th>
          <th scope="col">Rider</th>
          <th scope="col">Avg W</th>
          <th scope="col">Avg W/kg</th>
          <th scope="col">HR bpm</th>
          <th scope="col" v-if="!hidePoints">Points</th>
          <th scope="col" v-if="hidePoints">Time</th>
          <th scope="col" v-if="hidePoints">Gap</th>
        </tr>

        <tr scope="row" v-if="!players.length" class="text-center" >
          <td scope="col" colspan="8" style=" line-height: 57px;"> {{ tableMessage }}</td>
        </tr>

        <tr scope="row" :class="index === 0 && 'active'" v-for="(row, index) in players" :key="row.rank" @click="$emit('spectatorMode', row)">
          <td scope="col">
            <span :class="index === 0 && 'active'">{{ row.rank }}</span>
          </td>
          <td scope="col">
            <p v-html="mapCountryFlag(row.userCountryFlag, '40px', '40px')"></p>
          </td>
          <td scope="col">
            <div class="div-flex">
              <div class="jersey-img div-flex">
                <div v-html="row.jerseyImage"></div>
                <div class="user-category" v-if="row.categoryId != 0">{{ row.categoryId }}</div>
              </div>
              <div class="">
                <p class="mb-0 playerNameTruncate" v-html="row.userFullName"></p>
                <p class="teamsText">{{ row.teamName }}</p>
              </div>
            </div>
          </td>
          <td scope="col">{{ row.avgPower }}</td>
          <td scope="col">{{ row.wattPerKG }}</td>
          <td scope="col">{{ row.avgHeartRate }}</td>

          <td scope="col" v-if="!hidePoints">{{ applyDash(row.selectionStatus) ? '-' : row.points }}</td>
          <td scope="col" v-if="hidePoints">{{
            applyDash(row.selectionStatus) ? '-' : formatTime(row.finishedTime)
          }}
          </td>
          <td scope="col" v-if="hidePoints">
            {{ applyDash(row.selectionStatus) ? '-' : '+' + formatTime(row.finishedTime - players[0].finishedTime) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <!--    </div>-->
  </div>
</template>

<script>
import $ from 'jquery';
import "datatables.net-bs4/js/dataTables.bootstrap4.min.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import 'datatables.net-fixedcolumns-bs4/js/fixedColumns.bootstrap4.min.js';
import 'datatables.net-colreorder-bs4/js/colReorder.bootstrap4.min.js';
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css'

//import config from '@/config/app.config.ts';
import { columnsV2 } from "@/views/events/result.dto.ts";
import {
  formatTime,
  IsSeriesPointAndTimeBasedEvents,
  IsSinglePointAndTimeBasedEvents,
  IsSinglePointBasedEvents,
  mapCountryFlag
} from "@/shared/events/event.helpers.ts";

export default {
  name: "DataTable-Vue",
  emits: ["spectatorMode", "getTopRankedPlayers"],
  props: [
    'isWatt',
    'result',
    'event',
    'activeItem',
    'isLive',
    'loader',
    'selectedColumns',
    'isSeriesEvent',
    'noResultsDataMessage',
    'isMobileDevice',
  ],
  data() {
    return {
      formatTime: formatTime,
      mapCountryFlag: mapCountryFlag,
      data: this.result,
      //loader: false,
      tableHeight: this.result.length * 43,
      tableSort: {},
      columns: columnsV2,
      tableMessage: this.noResultsDataMessage,
      players: [],
      hidePoints: true,
    }
  },



  created() {
    // window.addEventListener("scroll", this.handleScroll);
  },

  unmounted() {
    // window.removeEventListener("scroll", this.handleScroll);
  },

  watch: {
    noResultsDataMessage: {
      handler: function (values) {
        this.tableMessage = values
      },
      deep: true,
      immediate: true
    },

  },

  async mounted() {
    //this.loader = true;
    // await this.getTable();
    await this.showHidePoints();
    this.players = await this.getRows();
    // document.addEventListener('touchmove', (e) => { e.preventDefault(); }, { passive: false });
  },

  methods: {

    applyDash(status) {
      return !this.isLive && ['DNF', 'DSQ', 'DNS', 'ANL', 'TIE', 'SFT'].includes(status);
    },

    async showHidePoints() {
      if (IsSeriesPointAndTimeBasedEvents(this.event) && this.isSeriesEvent && !['individual', 'master', 'young'].includes(this.activeItem.type)) {
        this.hidePoints = false;
      } else if (IsSinglePointAndTimeBasedEvents(this.event) && !this.isSeriesEvent && !['individual'].includes(this.activeItem.type)) {
        this.hidePoints = false;
      } else if (IsSinglePointBasedEvents(this.event) && !this.isSeriesEvent) {
        this.hidePoints = false;
      } else {
        this.hidePoints = true;
      }
    },

    handleScroll() {
      const scrollDiv = document.getElementById("individual-result-body");

      if (window.scrollY && scrollDiv.scrollTop > 0) {
        $('.dataTables_scrollHead, .DTFC_LeftHeadWrapper').css({
          // scroll to that element or below it
          position: 'static'
        });

        scrollDiv.scrollTop = 0;
      }
    },

    tblBodyScroll() {
      const scrollDiv = document.getElementById("individual-result-body");
      const divTop = document.getElementById("individual-result").getBoundingClientRect().top;
      if (scrollDiv.scrollTop > 0) {
        $('.dataTables_scrollHead').css({
          // scroll to that element or below it
          position: 'fixed',
          top: parseInt(divTop, "0") + "px",
          "z-index": 99999,
          width: scrollDiv.offsetWidth
        });

        $('.DTFC_LeftHeadWrapper').css({
          // scroll to that element or below it
          position: 'fixed',
          top: parseInt(divTop, "0") + "px",
          left: 15,
          "z-index": 99999999,
          width: 150
        });
      } else {
        $('.dataTables_scrollHead, .DTFC_LeftHeadWrapper').css({
          // scroll to that element or below it
          position: 'static'
        });
      }
    },

    hideColumn() {
      this.tableSort.columns().visible(false);

      this.selectedColumns.map(col => {
        this.tableSort.column(`${col}:name`).visible(true)
      });

      this.tableSort.columns.adjust().draw();
    },

    getColumns(withData = true) {
      const cols = [...this.columns].filter(e => e);
      if (withData) return cols;
      return cols.map(c => ({ data: c.id }));
    },

    getColumnsDefs() {
      const columns = [
        { orderable: false, targets: 'no-sort' },
        { orderable: false, targets: -1, visible: false },
        // {className: 'tx-l', 'targets': [4]},
      ];
      this.getColumns().map((col, i) => {
        columns.push({
          width: col.width || 100,
          className: col.className || 'text-center',
          targets: i,
          name: col.id,
          orderable: col.orderable || false,
        });
      })
      return columns;
    },

    applyDataMapping(data, isRank = true) {

      let rankedData = [];
      if (
        (this.isSeriesEvent && IsSeriesPointAndTimeBasedEvents(this.event) && this.activeItem.type === 'overallgate') ||
        (!this.isSeriesEvent && IsSinglePointAndTimeBasedEvents(this.event) && this.activeItem.type === 'overallgate') ||
        (!this.isSeriesEvent && IsSinglePointBasedEvents(this.event) && this.activeItem.type === 'overallgate')) {
        rankedData = data.sort((a, b) => {
          if (a.points > b.points) {
            return -1;
          } else if (a.points < b.points) {
            return 1;
          }

          if (a.finishedTimeOverall < b.finishedTimeOverall) {
            return -1;
          } else if (a.finishedTimeOverall > b.finishedTimeOverall) {
            return 1;
          }
          return 0
        });
      } else {
        rankedData = data.sort((a, b) => a.finishedTime - b.finishedTime);
      }

      return rankedData.map((r, index) => {

        const row = {};
        //const rank = r['rank'];
        const rank = isRank ? index + 1 : r.selectionStatus;
        const firstFinishedTime = rankedData[0].finishedTime;

        const rowData = Object.assign({ gapTimeNew: r.finishedTime - firstFinishedTime }, r);

        this.getColumns().forEach(c => {
          row[c.id] = this.colFormat(rank, index, rowData, c);
        });

        return row;
      });

    },

    getRows() {
      let results = [];

      if (!this.isLive) {

        // remove deleted players
        this.data = this.data.filter((x) => !x.deleted_at);

        // filter dq/nonDq players
        const status = ['DNF', 'DSQ', 'DNS', 'ANL', 'TIE', 'SFT'];
        const qItems = this.applyDataMapping(this.data.filter((x) => !status.includes(x.selectionStatus)));
        const dqItems = this.applyDataMapping(this.data.filter((x) => status.includes(x.selectionStatus)), false);

        results = [...qItems, ...dqItems];
      } else {
        results = this.applyDataMapping(this.data);
      }

      // push top 3 ranked players from child to parent
      if (this.activeItem.type === 'individual') {
        this.$emit('getTopRankedPlayers', results.slice(0, 3))
      }

      return results;
    },

    colFormat(rank, index, row, col) {
      let colData = "";

      if (col.format && typeof col.format === "function") {
        colData += col.format(row[col.id])
      } else if (col.format) {
        colData += `${row[col.id]} ${" "} ${col.format}`;
      } else if (col.id === 'rank') {
        colData += rank;
      } else {
        colData += row[col.id] ??= col.defaultValue;
      }
      return colData;
    },

    // async getTable(destroy = false) {
    //   try {
    //
    //     this.tableSort = await $('#resultTable').DataTable({
    //       destroy: destroy,
    //       data: this.getRows(),
    //       columns: this.getColumns(false),
    //       paging: false,
    //       searching: false,
    //       info: false,
    //       'table-layout': 'fixed',
    //       order: [2, "asc"],
    //       columnDefs: this.getColumnsDefs(),
    //       scrollY: false,
    //       scrollX: true,
    //       scrollCollapse: true,
    //       fixedColumns: {
    //         leftColumns: 2
    //       },
    //       colReorder: false,
    //       // preDrawCallback: async () => {
    //       //   $('#resultTable tbody td').addClass("blurry");
    //       // },
    //       // drawCallback: () => {
    //       //   $('#resultTable tbody td').addClass("blurry");
    //       //   $('#resultTable tbody').fadeIn(800);
    //       //   setTimeout(function () {
    //       //     $('#resultTable tbody td').removeClass("blurry");
    //       //     $('.DTFC_LeftBodyLiner tbody td').removeClass("blurry");
    //       //   }, 600);
    //       // },
    //     }).columns.adjust().fixedColumns().relayout();
    //
    //     this.hideColumn();
    //     return this.tableSort;
    //   } catch (e) {
    //     console.log("Datatable Error", e.message);
    //   }
    // },
  }
};
</script>
